import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { PolizaContableForm } from "./form";
const PolizaContableFormRx = componentToRx(PolizaContableForm);
type Entity = models.PolizaContable;
const resource = resources.Contabilidad;

interface Props {
    match: match<{ id: string }>
}

class PolizaContableEditComp extends React.PureComponent<Props> {
    constructor(props: Props) {
        super(props);
        this.state = { };
    }
    idStr = (props: Props) => this.props.match.params.id;
    id = createSelectorRx(this.idStr , id => id =="new" ? "new" : Number.parseInt(id) );
    value = createSelectorRx(this.id, id => observeResource(resource.GetPoliza, id));

    render() {
        const value = this.value(this.props);
        return <PolizaContableFormRx value={value} />;
    }
}

export const PolizaContableEdit = withRouter(PolizaContableEditComp);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/polizas/edit/edit.tsx